import { FC } from 'react'

import { useQueryApi } from 'peach/data/useQueryApi'

import {
  isForbiddenError,
  isNotFoundError,
  isUnauthorizedError,
  isUnprocessableContentError,
  R,
} from 'core/helpers'
import { useCompanyRoleGet } from 'core/types'

import ModelLink from './ModelLink'

type RoleLinkProps = {
  roleId: string
}

const RoleLink: FC<RoleLinkProps> = ({ roleId }) => {
  const [_, { companyId }] = useQueryApi()
  const { data: role, isLoading } = useCompanyRoleGet({
    companyId,
    roleId,
    options: {
      throwOnError: (error) =>
        R.isNot(isForbiddenError)(error) &&
        R.isNot(isNotFoundError)(error) &&
        R.isNot(isUnprocessableContentError)(error) &&
        R.isNot(isUnauthorizedError)(error),
    },
  })

  return <ModelLink id={roleId} isLoading={isLoading} model={role} />
}

export default RoleLink
